import {IconButton, IconTextButton, TextButton} from 'Components/Button';
import { useState, useEffect} from "react";
import { Stack, Button, Table, Form } from "react-bootstrap";
import ChevronLeft from '@mui/icons-material/Add';

import {Link} from 'react-router-dom';
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";
import { H1 } from 'Components/Typography/Headings';

import { Row, Card, Col, Badge } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { GetCheckboxInputObj } from './Private/Organization/Data files/UserFields';
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';


function ExampleElements () {

    var [checkTest,checkTestInputDispatch] = GetCheckboxInputObj({
        id: 'inputtest',
        name: 'user_',
        value: 'check',
        checkBoxes: [
            {
                id: "contactVerify",
                label: "I verify the above user information is correct.",
                title: "Check the checkbox to verify if the above User Information is correct",
                name: "contactVerify",
                value: false,
                isChecked: false,
                //onChange: handleCheckChange,
                disabled: false
            }
        ],
        label: 'Verify User Information',
        description: '',
        title: '',
        placeholder: '',
        required: true,
        isInvalid: false,
        errors: [],
        disabled: '',
        readOnly: '',
        hideFieldOrgTypes: []
    });

    var displayErrors = (errors) => {
        
        return (
            <div>
                {errors.length > 0 ? errors.map((errorText,index) => 
                    <Stack key={index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>
                    
                ) : null}
            </div>
        );
    }

    const states = ["","hover","focus","active","disabled"];
    const headingweights = ["regular", "semi-bold", "bold"];

    var iconViewBox = "6.5 7 12 10";

    return (
        
        <div>
            <Link className="table-action" tabIndex={0} 
                title={"Click the link to view the information about "} 
                to={{
                pathname: "/manage/PSO/viewOrganization",
                }} 
                state={{id: 2569, orgType: "PSO"}}
            >
                View ORG
            </Link>
            <h1>Typography</h1>

            <h2 className="m-5">Headings</h2>
            
            <h3>H1</h3>

            
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h1 className={"blue " + v}>Sample Heading</h1>
                                    <pre><code>{"<h1 className='" + 'blue ' + v + "'>Sample Heading</h1>"}</code></pre>
                                </td>
                                <td>
                                    <h1 className={"black " + v}>Sample Heading</h1>
                                    <pre><code>{"<h1 className='" + 'black ' + v + "'>Sample Heading</h1>"}</code></pre>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>

            <h3>H2</h3>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h2 className={"blue " + v}>Sample Heading</h2>
                                </td>
                                <td>
                                    <h2 className={"black " + v}>Sample Heading</h2>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>

            <h3>H3</h3>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h3 className={"blue " + v}>Sample Heading</h3>
                                </td>
                                <td>
                                    <h3 className={"black " + v}>Sample Heading</h3>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>

            <h3>H4</h3>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h4 className={"blue " + v}>Sample Heading</h4>
                                </td>
                                <td>
                                    <h4 className={"black " + v}>Sample Heading</h4>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>

            <h3>H5</h3>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h5 className={"blue " + v}>Sample Heading</h5>
                                </td>
                                <td>
                                    <h5 className={"black " + v}>Sample Heading</h5>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>


            <h1>Buttons</h1>
            <h2 className="m-5">TextButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="normal" content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="outline" content={"Text Button - Outline"}/>
                                </td>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="tertiary" content={"Text Button - Tertiary"}/>
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>
            
            <h2 className="m-5">IconTextButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="normal" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="outline" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="tertiary" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>

            <h2 className="m-5">IconButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="normal" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="outline" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="tertiary" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>




            <h1>Form Elements</h1>
            <h2 className="m-5">TextButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="normal" content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="outline" content={"Text Button - Outline"}/>
                                </td>
                                <td>
                                    <TextButton className={"me-2 " + v} variant="tertiary" content={"Text Button - Tertiary"}/>
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>
            
            <h2 className="m-5">IconTextButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="normal" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="outline" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                                <td>
                                    <IconTextButton className={"me-2 " + v} variant="tertiary" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Text Button - Normal"}/>
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>

            <h2 className="m-5">IconButton</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Variant = <span className="text-danger">normal</span></th>
                        <th>Variant = <span className="text-danger">outline</span></th>
                        <th>Variant = <span className="text-danger">tertiary</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        states.map((v) => 
                            <tr>
                                <th>
                                    State = <span className="text-primary">{v=="" ? "normal" : v }</span>
                                </th>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="normal" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="outline" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                                <td>
                                    <IconButton className={"me-2 " + v} variant="tertiary" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} />
                                </td>
                            </tr>
                        )      
                    }
                    
                </tbody>
            </Table>

            <h1>Forms</h1>
            <h2 className="m-5">Search Bar</h2>

            <h2 className="m-5">Text</h2>
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Status = <span className="text-danger">Default</span></th>
                        <th>Status = <span className="text-danger">Error</span></th>
                        <th>Status = <span className="text-danger">Success</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        [true,false].map((i)=> 
                            ["default","hover","focus","disabled"].map((v) => 
                                <tr>
                                    <th>
                                        State = <span className="text-primary">{v}</span>
                                        <br></br>
                                        Icon = <span className="text-primary">{i}</span>
                                    </th>
                                    <td>
                                        <Form.Control
                                            className={i==true? "":"no-icon"}
                                            type="text"
                                            name="Sample Input"
                                            value="Test Value"
                                            placeholder="Placeholder_input"
                                            title="Title"
                                            isInvalid=""
                                            isValid=""
                                            readOnly=''
                                            disabled={v=="disabled" ? 'disabled' : ''}
                                        />
                                        <Form.Text className="text-muted">
                                            helper_text_input
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {displayErrors(["this is an error"])}
                                        </Form.Control.Feedback>

                                        
                                        {/*<pre><code>{"<h1 className='" + 'blue ' + v + "'>Sample Heading</h1>"}</code></pre>*/}
                                    </td>
                                    <td>
                                        <Form.Control
                                        className={i==true? "":"no-icon"}
                                            type="text"
                                            name="Sample Input"
                                            value="Test Value"
                                            placeholder="Placeholder_input"
                                            title="Title"
                                            isInvalid="invalid"
                                            isValid=""
                                            readOnly={''}
                                            disabled={v=="disabled" ? 'disabled' : ''}
                                        />
                                        <Form.Text className="text-muted">
                                            helper_text_input
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {displayErrors(["this is an error"])}
                                        </Form.Control.Feedback>
                                        
                                        
                                    </td>
                                    <td>
                                        <Form.Control
                                            className={i==true? "":"no-icon"}
                                            type="text"
                                            name="Sample Input"
                                            value="Test Value"
                                            placeholder="Placeholder_input"
                                            title="Title"
                                            isInvalid=""
                                            isValid="valid"
                                            //isInvalid={isInvalid ? "invalid":""}
                                            readOnly={''}
                                            disabled={v=="disabled" ? 'disabled' : ''}
                                        />
                                        <Form.Text className="text-muted">
                                            helper_text_input
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {displayErrors(["this is an error"])}
                                        </Form.Control.Feedback>
                                        <Form.Control.Feedback type="valid">
                                            {displayErrors(["this is a success"])}
                                        </Form.Control.Feedback>
                                        
                                        
                                    </td>
                                </tr>
                            )      
                        )
                        
                    }
                </tbody>
            </Table>
            <Form.Control
                type="text"
                name="Sample Input"
                value="Test Value"
                placeholder="Placeholder_input"
                title="Title"
                isInvalid="invalid"
                //isInvalid={isInvalid ? "invalid":""}
                //readOnly={readOnly ? 'readOnly' : ''}
                //disabled={disabled ? 'disabled' : ''}
            />
            <Form.Text className="text-muted">
                helper_text_input
            </Form.Text>
            <Form.Control.Feedback type="invalid">
                {displayErrors(["this is an error"])}
            </Form.Control.Feedback>


            <h2 className="m-5">Checkbox</h2>

            <Col xl={10} lg={11} md={11} sm={12}>
                <Card className="p-4" >
                    <Card.Body className="text-start">
                    <Form>
                        <FormInputDisplay fieldData={checkTest} inputDispatch={checkTestInputDispatch} orgType={null} isHorizontal={true} hideLabel={false} horizontalForm={{is: true, labelCols: {lg:2}, inputCols: {lg:5}}}></FormInputDisplay>
                    </Form>
                </Card.Body> 
                </Card>
            </Col>
            <h2 className="m-5">Radio Button</h2>
            <h2 className="m-5">Switch</h2>
            <h2 className="m-5">TextArea</h2>
            
            <h3>H1</h3>

            
            <Table>
                <thead>
                    <tr>
                        <th width="15%"></th>
                        <th>Color = <span className="text-danger">Blue</span></th>
                        <th>Color = <span className="text-danger">Black</span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        headingweights.map((v) => 
                            <tr>
                                <th>
                                    Weight = <span className="text-primary">{v}</span>
                                </th>
                                <td>
                                    <h1 className={"blue " + v}>Sample Heading</h1>
                                    <pre><code>{"<h1 className='" + 'blue ' + v + "'>Sample Heading</h1>"}</code></pre>
                                </td>
                                <td>
                                    <h1 className={"black " + v}>Sample Heading</h1>
                                    <pre><code>{"<h1 className='" + 'black ' + v + "'>Sample Heading</h1>"}</code></pre>
                                </td>
                            </tr>
                        )      
                    }
                </tbody>
            </Table>
        </div>
    );
}

export default ExampleElements;